import vi from "@/types/vi";
import en from "@/types/en";

export const dictionaries = {
  vi,
  en,
};

export type Locale = keyof typeof dictionaries;
